import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GeneralImage } from "../../components";
import { formatDateTimeToShow } from "../../utils/utils";
import { GetArticles } from "../../interface/GeneralResponse";

interface ArticleProps {
  item?: GetArticles;
  link: string;
}

const ArticleCard: React.FC<ArticleProps> = ({ link, item }) => {
  const { t } = useTranslation();
  return (
    <Link to={link}>
      <div className="flex items-center gap-3">
        <GeneralImage
          src={item?.Image}
          alt={item?.Title}
          className="h-16 rounded-lg border shadow-sm"
          width="4rem"
        />
        <div className="w-full">
          <h1 className="line-clamp-1 font-bold">{item?.Title}</h1>
          <p className="text-body-text line-clamp-1 text-sm">
            {item?.Description}
          </p>
          <div className="text-text-secondary flex items-center justify-between rounded-[4px] bg-InputFieldColor px-2 py-1 pt-1 text-xs">
            <p>{t("app_name")}</p>
            <p>{item?.Date ? formatDateTimeToShow(item?.Date) : ""}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ArticleCard;
